import { formatApiDate } from 'Utils/date/apiDate';
import { formatAmountForLocale } from 'Utils/currency-config-for-locale/currencyConfigForLocale';
import { sortBy } from 'lodash';
export const getAmountExpirationVouchersValues = (
  vouchers: Array<VoucherEntity>,
  appContext: AppContext,
) => {
  const sortedVouchers = sortBy(vouchers, ({ validityEndDate }) => {
    return validityEndDate;
  });
  //return no amount if more than one
  const ftcAmount =
    sortedVouchers.length > 1 ? '' : formatVoucherValue(sortedVouchers?.[0], appContext.locale);
  const ftcExpirationDate = formatApiDate(sortedVouchers?.[0]?.validityEndDate, 'DD/MM/YYYY');
  return {
    ftcAmount,
    ftcExpirationDate,
  };
};
export const formatVoucherValue = (voucher: VoucherEntity, locale: string): string => {
  if (voucher.unit === 'PERCENTAGE' || voucher.unit === 'PERCENT') {
    return `${voucher.value}%`;
  } else {
    return formatAmountForLocale(voucher.value, locale, voucher.currency);
  }
};
